/** Maximum number of violations to fix in one batch (prevents context overflow) */
export const MAX_VIOLATIONS_PER_BATCH = 20;
